import { TaskPriorityLabelComponent } from './task-priority-label.component';

export default angular
  .module('sfMobile.components.task-priority-label', [])
  .component('sfTaskPriorityLabel', TaskPriorityLabelComponent).name;
